import { render, staticRenderFns } from "./CodeChecker.vue?vue&type=template&id=38d0e958&lang=pug&"
import script from "./CodeChecker.vue?vue&type=script&lang=js&"
export * from "./CodeChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports